module.exports = __webpack_public_path__ + "img/SDG-09-EN-INVERTED.b58f71ba.png";